import { APP_NAME, DYNAMIC_REMOTES, EXTERNAL_REMOTES_APPS } from '~/config/app.constants';

interface Remote {
  appName: string;
  children?: Remote[];
}

const remotes = require('../../../remotes') as Remote[];

function collectAppNames(remotes: Remote[], appNames: string[] = []): string[] {
  for (const { appName, children } of remotes) {
    appNames.push(appName);
    if (children && children.length) {
      collectAppNames(children, appNames);
    }
  }
  return appNames;
}

export const MicroApps = collectAppNames(remotes, [APP_NAME]);

export const DynamicApps = Object.values(DYNAMIC_REMOTES).map(
  ({ appName }: { appName: string }) => appName
);

export const ExternalApps = Object.values(EXTERNAL_REMOTES_APPS).map(
  ({ appName }: { appName: string }) => appName
);
